<form [formGroup]="searchForm" (ngSubmit)="submit()">
  <div class="d-flex flex-row gap-2 pt-2 w-100">

    <!-- Icon input group Bootstrap -->
    <div class="d-flex flex-row align-items-center w-100 custom-form-wrapper">
      <fa-icon [icon]="faSearch" class="custom-form-icon" style="color: lightgrey"></fa-icon>
      <input type="text" id="searchInput" formControlName="query" class="form-control custom-form-control rounded-3 border-2"
        [placeholder]="isFollowUp() ? 'Approfondisci...' : 'Cerca tramite AI...'" aria-label="search input field"
        size="large" />
    </div>

  </div>

  @if (!isFollowUp()) {
  <div class="text-center mt-2">
    <small id="searchInputHelp" class="text-secondary lh-1">
      Generative AI is powered by Google Cloud - Generative AI can make mistakes
    </small>
  </div>
  }
</form>